/** @module components/cloze-quiz */


import {SelectSpanChoice} from './SelectSpanChoice';


/**
 * Specifies the initial state of a [[SelectSpanPlaceholderChoice]].
 */
export interface SelectSpanPlaceholderChoiceInitialState {

    /**
     * Sets the text that should be displayed for this placeholder choice.
     */
    text: string;
}


/**
 * A [[SelectSpanChoice]] that is initially [[selected]] and never [[correct]].
 * You typically use this type for the first [[choice]] of a [[SelectSpan]].
 */
export class SelectSpanPlaceholderChoice extends SelectSpanChoice {

    /**
     * Initializes a new instance of the [[PlaceholderSelectChoice]] class.
     *
     * @param initialState Specifies the initial state for the new instance.
     * @param data An optional arbitrary object that gets passed to [[Model]]'s constructor.
     */
    public constructor(initialState: SelectSpanPlaceholderChoiceInitialState, data: object = {}) {
        super({
            correct: false,
            selected: true,
            ...initialState
        }, data);
    }
}
